import { render, staticRenderFns } from "./XyShop.vue?vue&type=template&id=11412c60&scoped=true&"
import script from "./XyShop.vue?vue&type=script&lang=js&"
export * from "./XyShop.vue?vue&type=script&lang=js&"
import style0 from "./XyShop.vue?vue&type=style&index=0&id=11412c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11412c60",
  null
  
)

export default component.exports